// src/components/common/custom-tooltip/CustomTooltip.tsx
import React, { useState } from "react";
import "./custom-tooltip.scss";

interface CustomTooltipProps {
  content: string | number | null;
  displayContent?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ content, displayContent, className = "", style }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!content) return null;

  return (
    <div
      className={`custom-tooltip-wrapper ${className}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      style={{ position: "relative", ...style }}
    >
      <span className="custom-tooltip-text">
        {displayContent ?? content}
      </span>

      {showTooltip && (
        <div className="custom-tooltip">{String(content)}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
